import React, { useState } from 'react';
import {
  Eye,
  EyeOff,
  Lock,
  LogIn,
  User
} from 'lucide-react';

const API = (
  process.env.REACT_APP_API_URL ||
  '/api'
).replace(/\/$/, '');

export default function Login({ onLogin }) {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [lembrar, setLembrar] = useState(true);
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const entrar = async event => {
    event.preventDefault();
    setErro('');
    setLoading(true);

    try {
      const response = await fetch(
        `${API}/auth/login`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            usuario,
            senha,
            lembrar
          })
        }
      );

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(
          data.error ||
          'Não foi possível entrar'
        );
      }

      onLogin(data);
    } catch (error) {
      setErro(
        error.message ||
        'Usuário ou senha inválidos'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="mx-auto w-16 h-16 rounded-2xl bg-blue-600 flex items-center justify-center shadow-lg shadow-blue-900/30">
            <Lock size={30} className="text-white" />
          </div>

          <h1 className="text-3xl font-bold text-white mt-5">
            Financy
          </h1>

          <p className="text-gray-400 mt-2">
            Acesso ao CRM Limpa Nome
          </p>
        </div>

        <form
          onSubmit={entrar}
          className="bg-gray-900 border border-gray-800 rounded-2xl p-7 shadow-2xl"
        >
          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Usuário
            </label>

            <div className="relative">
              <User
                size={18}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"
              />

              <input
                type="text"
                value={usuario}
                onChange={event =>
                  setUsuario(event.target.value)
                }
                autoComplete="username"
                autoFocus
                required
                className="w-full bg-gray-950 border border-gray-700 rounded-lg py-3 pl-10 pr-4 text-white outline-none focus:border-blue-500"
                placeholder="Digite seu usuário"
              />
            </div>
          </div>

          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Senha
            </label>

            <div className="relative">
              <Lock
                size={18}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"
              />

              <input
                type={mostrarSenha ? 'text' : 'password'}
                value={senha}
                onChange={event =>
                  setSenha(event.target.value)
                }
                autoComplete="current-password"
                required
                className="w-full bg-gray-950 border border-gray-700 rounded-lg py-3 pl-10 pr-11 text-white outline-none focus:border-blue-500"
                placeholder="Digite sua senha"
              />

              <button
                type="button"
                onClick={() =>
                  setMostrarSenha(valor => !valor)
                }
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300"
              >
                {mostrarSenha
                  ? <EyeOff size={19} />
                  : <Eye size={19} />}
              </button>
            </div>
          </div>

          <label className="flex items-center gap-3 text-sm text-gray-300 mb-6 cursor-pointer">
            <input
              type="checkbox"
              checked={lembrar}
              onChange={event =>
                setLembrar(event.target.checked)
              }
              className="w-4 h-4 rounded"
            />

            Manter conectado neste dispositivo
          </label>

          {erro && (
            <div className="mb-5 px-4 py-3 rounded-lg border border-red-800 bg-red-950/50 text-red-300 text-sm">
              {erro}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white font-semibold rounded-lg py-3"
          >
            <LogIn size={19} />

            {loading
              ? 'Entrando...'
              : 'Entrar no painel'}
          </button>
        </form>

        <p className="text-center text-xs text-gray-600 mt-5">
          Ambiente seguro · Financy Soluções Financeiras
        </p>
      </div>
    </div>
  );
}
